// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"648d3c7e","703":"e9f43c29"}[chunkId] + ".chunk.js";
};